module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0093.png.7fb2a165.jpg";